export enum CaseState {
  CLOSE = 0,
  OPEN = 1,
  NOT_SPECIFIED,
}
